import { ENV } from '@/configs/env';

export const getH5creditCardBaseUrl = () => {
    let BASE_URL = 'https://dsim429-api.intra.xiaojukeji.com/baldr-outside-app';

    // 正式环境
    if (process.env.BUILD_ENV === ENV.ONLINE) {
        if (/didifinance\.com/.test(window.location.host)) {
            BASE_URL = 'https://sofipo-app.didifinance.com/baldr-outside-app';
        } else {
            BASE_URL = 'https://manhattan-app.didiglobal.com/baldr-outside-app';
        }
    }

    // 预发环境
    if (process.env.BUILD_ENV === ENV.PRE) {
        if (/didifinance\.com/.test(window.location.host)) {
            BASE_URL = 'https://sofipo-pre.intra.didifinance.com/gateway/baldr/tpl/apply';
        } else {
            BASE_URL =
                'http://pre.global.manhattan.app.intra.xiaojukeji.com/gateway/baldr/tpl/apply';
        }
    }

    // sim环境
    if (process.env.BUILD_ENV === ENV.SIM) {
        if (/didifinance\.com/.test(window.location.host)) {
            BASE_URL = 'https://sofipo-app.didifinance.com/baldr-outside-app';
        } else {
            BASE_URL = `${window.location.origin.replace('page', 'api')}/baldr-outside-app`;
        }
    }

    return BASE_URL;
};
